import React,{useEffect, useState} from 'react';
import ModelViewer from './components/ModelViewer';
import ShinchanViewer from './components/ShinchanViewer';
const App: React.FC = () => {
  const [loading, setLoading] = useState(true);

  const fakeRequest = () => {
    return new Promise<void>(resolve => setTimeout(() => resolve(), 2500));
  };
  useEffect(() => {
    fakeRequest().then(() => {
      const el = document.querySelector(".loader-container") as HTMLElement | null;
      if (el) {
        el.remove(); 
        setLoading(false);
      }
    });
  }, []);

  if (loading) {
    return null;
  }

  return (
    <div className="flex flex-col text-center items-center w-full h-auto  bg-white">
      <TitleBar />
      <StaticImage2/>
      <StaticImage />
      <h1 className='text-center mt-20 text-3xl font-bold'>Swipe the model below!</h1>
      <ModelViewer />
      <br></br>
      <h1 className='text-red-500 text-6xl font-extrabold drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)] my-5 select-none'>SHINCHAN</h1>
      <div className='bg-yellow-300'>
      <ShinchanViewer />
      </div>
      <ShinInfo />
      <Shincheese/>
    </div>

  );
};
const TitleBar: React.FC = () => {
  return (
    <div className="flex w-3/6 h-auto bg-white items-center pt-10">
      <img src='/images/shintitle.png' alt='img-til' className='drop-shadow-[0_5px_1.5px_rgba(0,0,0,1)]'></img>
    </div>
  );
}
const StaticImage: React.FC = () => {
  return (
    <div className="flex w-full h-auto justify-center text-center items-center ">
      <img src='/images/shinchanimg1.png' alt='img1' width={650} className='z-20 border-t-8 border-x-8 border-dashed border-black/80'></img>
    </div>
  )
}
const StaticImage2: React.FC = ()=>{
  return(
    <div>
    <h1 className='text-[5vw] text-red-500 font-extrabold  drop-shadow-[0_5px_1.5px_rgba(0,0,0,1)]  top-64 z-50 select-none pb-5'>LeNekoza</h1>
    <img src="/images/shinchanimg2.png" alt="img2" width={300} className=' z-10 drop-shadow-[0_2.5px_6.5px_rgba(0,0,0,0.8)]'/>
    </div>
  )
}
const ShinInfo: React.FC = () => {
  return (
    <div className='w-auto h-fit bg-black/80 mb-10 p-2 text-center'>
    <article className='text-[1.5em] text-white border-yellow-400 border-dotted border-[0.4em] p-3 select-none'>
   <h1 className='font-bold'> Exploring the World of Shinchan Nohara: A Mischievous Icon</h1>
Shinchan Nohara, the brainchild of creator Yoshito Usui, burst onto the scene in 1990 through the manga "Crayon Shin-chan." With his trademark red shirt, white shorts, and unruly hair, Shinchan's mischievous adventures have captured hearts globally.

Character at a Glance:
Shinchan, a five-year-old with boundless energy, delights in audacious behavior and speaking his mind. His innocent mischief and genuine care for his loved ones make him universally endearing.

Distinct Humor and Themes:
"Crayon Shin-chan" combines slapstick, wordplay, and cultural humor. It draws laughs from candid interactions, addressing societal matters with a light touch.

Global Phenomenon:
Shinchan's universal appeal has transcended borders, charming audiences of all ages. The anime adaptation amplified his popularity, sharing his world through captivating visuals and infectious laughter.

Impact and Adaptations:
The character's legacy lives on through movies, video games, merchandise, and spin-offs. While facing controversies, the series tackles life's facets with humor, demonstrating its power to unite and entertain.

Enduring Legacy:
Despite creator Yoshito Usui's tragic passing in 2009, Shinchan's spirit persists through the dedication of colleagues and admirers. His adventures remind us of the joy in simple moments and the bonds laughter creates.

In a world where animated characters come and go, Shinchan Nohara's ability to evoke laughter, unity, and a touch of mischief has solidified his place as an iconic figure in global pop culture.
    </article>
    </div>
  )
}

const Shincheese: React.FC = () => {
  return(
    <>
    <img src='/images/shinchanimg3.png' width={600} alt='cheese' className='scale-50 drop-shadow-[1px_1px_100px_rgba(255,255,0,1)] '></img>
    </>
    )
}
export default App;
